/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const NumbersForMac32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <defs>
            <linearGradient id="prefix__a" x1="50.004%" x2="50.004%" y1="-.002%" y2="99.998%">
                <stop offset="0%" stopColor="#057DA4" />
                <stop offset="100%" stopColor="#0045CB" />
            </linearGradient>
            <linearGradient id="prefix__b" x1="49.999%" x2="49.999%" y1="-.002%" y2="99.998%">
                <stop offset="0%" stopColor="#23CAFF" />
                <stop offset="100%" stopColor="#2069F3" />
            </linearGradient>
            <linearGradient id="prefix__c" x1="50.004%" x2="50.004%" y1="-.003%" y2="99.997%">
                <stop offset="0%" stopColor="#D08500" />
                <stop offset="100%" stopColor="#E47202" />
            </linearGradient>
            <linearGradient id="prefix__d" x1="49.999%" x2="49.999%" y1="-.003%" y2="99.997%">
                <stop offset="0%" stopColor="#FDB01F" />
                <stop offset="100%" stopColor="#FF901A" />
            </linearGradient>
            <linearGradient id="prefix__e" x1="50.004%" x2="50.004%" y1="-.003%" y2="99.997%">
                <stop offset="0%" stopColor="#D23242" />
                <stop offset="100%" stopColor="#C00820" />
            </linearGradient>
            <linearGradient id="prefix__f" x1="49.999%" x2="49.999%" y1="-.003%" y2="99.997%">
                <stop offset="0%" stopColor="#EF4B5B" />
                <stop offset="100%" stopColor="#E12B41" />
            </linearGradient>
            <linearGradient id="prefix__g" x1="50.004%" x2="50.004%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#49CC38" stopOpacity={0.997} />
                <stop offset="100%" stopColor="#00A106" />
            </linearGradient>
            <linearGradient id="prefix__h" x1="49.999%" x2="49.999%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#79F966" />
                <stop offset="100%" stopColor="#16D620" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#969696"
                d="M22.687 0c3.2 0 4.363.356 5.525.985a6.677 6.677 0 012.803 2.803c.63 1.162.985 2.325.985 5.525v13.374c0 3.2-.356 4.363-.985 5.525a6.677 6.677 0 01-2.803 2.803c-1.162.63-2.325.985-5.525.985H9.313c-3.2 0-4.363-.356-5.525-.985a6.677 6.677 0 01-2.803-2.803C.355 27.05 0 25.887 0 22.687V9.313c0-3.2.356-4.363.985-5.525A6.677 6.677 0 013.788.985C4.95.355 6.113 0 9.313 0h13.374z"
            />
            <path
                fill={vars.white}
                d="M9.313.547h13.374c3.05 0 4.157.315 5.265.916a6.36 6.36 0 012.585 2.585c.601 1.108.916 2.215.916 5.265v13.374c0 3.05-.315 4.157-.916 5.265a6.36 6.36 0 01-2.585 2.585c-1.108.601-2.215.916-5.265.916H9.313c-3.05 0-4.157-.315-5.265-.916-1.108-.602-1.997-1.463-2.585-2.585-.588-1.121-.916-2.215-.916-5.265V9.313c0-3.05.315-4.157.916-5.265.602-1.108 1.463-1.997 2.585-2.585C5.169.875 6.263.547 9.313.547z"
            />
            <path
                fill="url(#prefix__a)"
                d="M22.017 7.658h3.419c.3 0 .547.246.547.547v18.598a.548.548 0 01-.547.547h-3.419a.55.55 0 01-.547-.547V8.205c0-.3.246-.547.547-.547z"
            />
            <path
                fill="url(#prefix__b)"
                d="M22.017 7.658h3.419c.15 0 .273.123.273.274v19.145c0 .15-.123.273-.273.273h-3.419a.274.274 0 01-.273-.273V7.932c0-.15.123-.274.273-.274z"
            />
            <path
                fill="url(#prefix__c)"
                d="M11.624 10.803h3.419c.3 0 .547.247.547.547v15.453a.548.548 0 01-.547.547h-3.42a.548.548 0 01-.546-.547V11.35c0-.3.246-.547.547-.547z"
            />
            <path
                fill="url(#prefix__d)"
                d="M11.897 10.803h2.872a.55.55 0 01.547.547v15.453a.548.548 0 01-.547.547h-2.872a.55.55 0 01-.547-.547V11.35c0-.3.247-.547.547-.547z"
            />
            <path
                fill="url(#prefix__e)"
                d="M6.427 16.82h3.42c.3 0 .546.247.546.548v9.435a.548.548 0 01-.547.547H6.427a.55.55 0 01-.547-.547v-9.435c0-.301.246-.547.547-.547z"
            />
            <path
                fill="url(#prefix__f)"
                d="M6.7 16.82h2.873c.3 0 .547.247.547.548v9.435a.548.548 0 01-.547.547H6.7a.548.548 0 01-.547-.547v-9.435c0-.301.246-.547.547-.547z"
            />
            <path
                fill="url(#prefix__g)"
                d="M16.82 4.24h3.42c.3 0 .546.245.546.546v21.88a.549.549 0 01-.547.548h-3.418a.548.548 0 01-.547-.547V4.787c0-.302.246-.548.547-.548z"
            />
            <path
                fill="url(#prefix__h)"
                d="M16.82 4.24h3.42c.15 0 .273.122.273.273V26.94c0 .15-.123.274-.274.274h-3.418a.275.275 0 01-.274-.274V4.513c0-.15.123-.274.274-.274z"
            />
        </g>
    </AccessibleSVG>
);

export default NumbersForMac32;
